import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react';

import { FormLabel, RequiredIndicator, chakra } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useFormField } from './FormField.ctx';

export type FormFieldLabelProps = ComponentPropsWithoutRef<typeof FormLabel>;

export const FormFieldLabel = forwardRef<
  ElementRef<typeof FormLabel>,
  ComponentPropsWithoutRef<typeof FormLabel>
>((props, ref) => {
  const { t } = useTranslation(['common']);

  const { optionalityHint, error } = useFormField();

  return (
    <FormLabel
      ref={ref}
      m={0}
      requiredIndicator={
        optionalityHint === 'required' ? (
          <RequiredIndicator color={error ? 'red.500' : 'gray.900'} m={0} />
        ) : null
      }
      display="flex"
      alignItems="baseline"
      gap={1.5}
      fontSize="sm"
      color="gray.700"
      optionalIndicator={
        optionalityHint === 'optional' ? (
          <chakra.small
            fontSize="xs"
            textTransform="none"
            fontWeight="normal"
            color="gray.600"
          >
            ({t('common:optional')})
          </chakra.small>
        ) : null
      }
      {...props}
    />
  );
});
FormFieldLabel.displayName = 'FormFieldLabel';
